import styled from 'styled-components'
import { colors } from '../theme'
import { lighten, darken } from 'polished'

interface ButtonProps {
  marginTop?: number;
  fullWidth?: boolean;
  inverted?: boolean;
  mobileOnly?: boolean;
}

const Button =
  styled.button <
  ButtonProps >
  `
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid;
  border-color: ${colors.primary};
  border-radius: 2px;
  background: transparent;
  color: ${colors.primary};
  outline: none;
  transition: all 0.4s ease;
  user-select: none;

  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px;`}

  ${({ fullWidth }) =>
    fullWidth &&
    `
    width: 100%;
    padding: 8px;
  `}

  

  &:focus:not(:hover) {
    background-color: ${darken(0.4, colors.primary)};
    border-color: ${lighten(0.2, colors.primary)};
    color: ${lighten(0.2, colors.primary)};
  }

  &:hover {
    background: ${colors.primary};
    color: ${colors.background};
    cursor: pointer;

    @media screen and (max-width: 850px) {
      background: transparent;
      color: ${colors.primary};
    }
  }

  ${({ inverted: muted }) =>
    muted &&
    `
    color: ${colors.foreground};
    border-color: ${colors.foreground};

    &:hover {
      background:rgb(178, 178, 178);
      border-color: ${colors.foreground};
      color:rgb(55, 55, 55);
    }

    &:active {
      background: ${colors.background};
      border-color: ${colors.foreground};
      color: ${colors.foreground};
    }
  `}

  i {
    color: ${colors.primary};
  }

  &:disabled {
    border-color: #444;
    color: #444;

    &:hover {
      background: ${colors.background};
      border-color: #444;
      color: #444;
      cursor: not-allowed;
    }

    i {
      color: #444;
    }

    &:active {
      position: initial;
    }
  }

  ${({ mobileOnly }) =>
    mobileOnly &&
    `
    @media screen and (min-width: 850px) {
      display: none;
    }
  `}
`

export default Button
